import * as React from 'react'
import { memo } from 'react'
const SvgUser = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 17.502 16"
  >
    <path d="M8.751 6.857a3.317 3.317 0 0 1-2.442-.987 3.316 3.316 0 0 1-.987-2.442A3.3 3.3 0 0 1 6.309.97a3.345 3.345 0 0 1 2.442-.971 3.345 3.345 0 0 1 2.442.971 3.3 3.3 0 0 1 .987 2.458 3.316 3.316 0 0 1-.987 2.442 3.317 3.317 0 0 1-2.442.987ZM0 16v-1.535a2.259 2.259 0 0 1 .457-1.371 3.165 3.165 0 0 1 1.208-.98 21.683 21.683 0 0 1 3.624-1.241 14.758 14.758 0 0 1 3.461-.424 14.757 14.757 0 0 1 3.461.424 21.683 21.683 0 0 1 3.624 1.241 3.166 3.166 0 0 1 1.208.98 2.259 2.259 0 0 1 .457 1.371V16Z" />
  </svg>
)
const Memo = memo(SvgUser)
export default Memo
